module.exports = __webpack_public_path__ + "img/1336400883.344c9f46.jpg";